const RELOADED_KEY = "inertia-page-chunk-reloaded"

// Loads an Inertia page chunk. When the chunk fails to arrive (dropped mobile
// connection, or an ECS rolling deploy serving the HTML and the chunk from
// different builds), reload once so the browser gets fresh HTML and matching
// chunks. The session flag stops a reload loop when the chunk is truly broken.
export async function loadPage<T>(
  load: () => Promise<T>,
  reload: () => void = () => window.location.reload(),
): Promise<T> {
  let page: T
  try {
    page = await load()
  } catch (error) {
    // Without storage (a browser blocking it) there is no loop guard, so
    // surface the failure rather than risk reloading forever.
    const alreadyReloaded = readFlag()
    if (alreadyReloaded !== false || !writeFlag()) throw error

    reload()
    // The page is going away; never settle so Inertia renders nothing stale.
    return new Promise<T>(() => undefined)
  }

  clearFlag()
  return page
}

// true / false, or null when storage is unavailable.
function readFlag(): boolean | null {
  try {
    return sessionStorage.getItem(RELOADED_KEY) !== null
  } catch {
    return null
  }
}

function writeFlag(): boolean {
  try {
    sessionStorage.setItem(RELOADED_KEY, "1")
    return true
  } catch {
    return false
  }
}

function clearFlag() {
  try {
    sessionStorage.removeItem(RELOADED_KEY)
  } catch {
    // Storage blocked: nothing was stored to clear.
  }
}
